import React from 'react';

import Base from './Base.jsx';

import NFTPriceChart from '../Components/NFTPriceChart/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-nft-price-chart';
  }

  renderElement(element) {
    var address = element.dataset.address;

    return (
      <NFTPriceChart address={address} />
    );
  }
}


export default EntryPoint;
